export const S3Config = {
    bucketName: "smsdevbucket22",
    region: "ca-central-1",
    accessKeyId: "AKIAZJUHHXPJHHGWDGX7",
    secretAccessKey: "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"
}
